import classNames from "classnames";
import {Svg} from "@/shared/ui/Svg";
import styles from "./ProductReviewStars.module.scss";

type Props = {
    rating: number;
    maxRating?: number;
};

export const ProductReviewStars = (
    {
        rating,
        maxRating = 5,
    }: Props
) => {
    const normalizedRating = Math.min(
        Math.max(rating, 0),
        maxRating,
    );

    return (
        <div className={styles.stars}>
            {Array.from({length: maxRating}, (_, index) => {
                const isActive = index < normalizedRating;

                return (
                    <Svg
                        key={index}
                        id="star"
                        className={classNames(
                            styles.starIcon,
                            {
                                [styles.starActive]: isActive,
                                [styles.starNotActive]: !isActive,
                            },
                        )}
                    />
                );
            })}
        </div>
    );
};
